import React from "react";
import { Button, Drawer } from "antd";
import { useHistory } from "react-router-dom";
import { MenuOutlined, UserOutlined, DownOutlined } from "@ant-design/icons";
import { getScrollTop, isMobile } from "@share/helper";
import s from "./s.module.scss";
import { useStore } from "@share/hook/use-store";
import logo from "./logowhite.png";

enum Screen {
  top = 0,
  screen1 = 1,
  screen2 = 2,
  screen3 = 3,
}

function Home() {
  const history = useHistory();
  const [visible, setVisible] = React.useState(false);
  const [currentScreen, setCurrentScreen] = React.useState(Screen.top);
  const [init, setInit] = React.useState(false);
  React.useEffect(() => {
    const loadListener = () => {
      const top = getScrollTop();
      const sc = document.getElementById("topScreen");
      if (sc) {
        const cScreen = Math.round(top / sc.clientHeight);
        setCurrentScreen(cScreen);
      }
    };
    document.body.addEventListener("scroll", loadListener);
    window.addEventListener("scroll", loadListener);
    setInit(true);

    return () => {
      document.body.removeEventListener("scroll", loadListener);
      window.removeEventListener("scroll", loadListener);
    };
  }, []);
  return (
    <div className={s.wrap}>
      <div className={s.top}>
        <div className={s.inner}>
          <h1>
            <img src={logo} width={138} />
          </h1>
          <div className={s.topMid}>
            <span
              onClick={() => {
                const sc = document.getElementById("topScreen");
                if (sc) {
                  const height = sc.clientHeight * 1;
                  document.body.scrollTo(0, height);
                  window.scrollTo(0, height);
                }
              }}
              className={currentScreen === Screen.screen1 ? s.active : ""}
            >
              Antminer S19 Pro
            </span>
            <span
              onClick={() => {
                const sc = document.getElementById("topScreen");
                if (sc) {
                  const height = sc.clientHeight * 2;
                  document.body.scrollTo(0, height);
                  window.scrollTo(0, height);
                }
              }}
              className={currentScreen === Screen.screen2 ? s.active : ""}
            >
              Innosilicon A10 Pro
            </span>
            <span
              onClick={() => {
                const sc = document.getElementById("topScreen");
                if (sc) {
                  const height = sc.clientHeight * 3;
                  document.body.scrollTo(0, height);
                  window.scrollTo(0, height);
                }
              }}
              className={currentScreen === Screen.screen3 ? s.active : ""}
            >
              Whatsminer M30s
            </span>
          </div>
          <div
            className={s.topRight}
            onClick={() => {
              setVisible(true);
            }}
          >
            <span className={s.login}>
              <span>LOGIN</span>
              <UserOutlined style={{ fontSize: 18 }} />
            </span>
            <MenuOutlined />
          </div>
        </div>
      </div>
      {(!visible || !isMobile()) && (
        <div className={s.order}>
          <span
            className={
              init
                ? `${s.btnBgDark} ${s.btnLeft} ${s.btnLeftShow}`
                : `${s.btnBgDark} ${s.btnLeft}`
            }
            onClick={() => {
              history.push("/shop");
            }}
          >
            {currentScreen === Screen.top ? "Hosting" : "Order now"}
          </span>
          <span
            className={
              init
                ? `${s.btnBgLight} ${s.btnRight} ${s.btnRightShow}`
                : `${s.btnBgLight} ${s.btnRight}`
            }
          >
            Learn more
          </span>
        </div>
      )}
      <span
        className={
          currentScreen === Screen.screen3
            ? `${s.moveUp} ${s.moveUpHide}`
            : s.moveUp
        }
        onClick={() => {
          const sc = document.getElementById("topScreen");
          if (sc) {
            let nextScreen = currentScreen + 1;
            if (nextScreen > 3) {
              nextScreen = 3;
            }
            const height = sc.clientHeight * nextScreen;
            document.body.scrollTo(0, height);
            window.scrollTo(0, height);
          }
        }}
      >
        <DownOutlined />
      </span>
      <div className={`${s.screen} ${s.screenTop}`} id="topScreen">
        <div className={s.maskTop}></div>
        <div className={s.inner}>
          <div
            className={init ? `${s.introTop} ${s.introTopShow}` : s.introTop}
          >
            <h3>Start Your Cryptocurrency Mining</h3>
            <p>Renewable Energy</p>
          </div>
        </div>
      </div>
      <div className={`${s.screen} ${s.screen1}`}>
        <div className={s.mark}></div>
        <div className={s.inner}>
          <div className={s.intro1}>
            <h3>Antminer S19 Pro</h3>
            <p>Mine the future</p>
          </div>
        </div>
      </div>
      <div className={`${s.screen} ${s.screen2}`}>
        <div className={s.mark}></div>
        <div className={s.inner}>
          <div className={s.intro1}>
            <h3>Innosilicon A10 Pro</h3>
            <p>Mine ETH</p>
          </div>
        </div>
      </div>
      <div className={`${s.screen} ${s.screen3}`}>
        <div className={s.mark}></div>
        <div className={s.inner}>
          <div className={s.intro1}>
            <h3>Whatsminer M30s</h3>
            <p>Mine BTC</p>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={false}
        onClose={() => {
          setVisible(false);
        }}
        visible={visible}
      >
        <ul className={s.drawer}>
          <li
            onClick={() => {
              history.push("/shop");
            }}
          >
            SHOP
          </li>
          <li>MARKET</li>
          <li>BALANCE</li>
          <li>COMMUNITY</li>
          <li>HOSTING</li>
          <li>ACCOUNT</li>
          <li>SUPPORT</li>
          <li>AGENT</li>
        </ul>
      </Drawer>
    </div>
  );
}

export default Home;
